import { render, staticRenderFns } from "./SelectingValuesSingleMultipleSelection.vue?vue&type=template&id=972e8fa2&"
import script from "./SelectingValuesSingleMultipleSelection.vue?vue&type=script&lang=js&"
export * from "./SelectingValuesSingleMultipleSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports